export const AdLogEvent = {
  AD_IMPRESSION: {amp: 'AD - Impression', ga: 'impression'},
  AD_BUTTON_CLICKED: {amp: 'AD - Button Clicked', ga: 'ad_button_click'},
  AD_BANNER_CLICKED: {amp: 'AD - Banner Clicked', ga: 'ad_banner_click'},
  AD_CLOSE_BUTTON_CLICKED:{amp: 'AD - Close Button Clicked', ga: 'ad_close_button_click'},
}